import MyBookingsPage from './list/MyBookingsPage.vue';

export default [
  {
    path: '/bookings',
    name: 'bookings',
    component: MyBookingsPage,
    meta: {
      title: 'Mes tickets'
    }
  },
];
